import { FC } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

type LazyImageProps = {
    imgSrc: string,
    height?: string,
    width?: string,
    className?: string
}

const LazyImage: FC<LazyImageProps> = ({ imgSrc, height, width, className }) => {
    return (
        <LazyLoadImage
            src={imgSrc}
            height={height}
            width={width}
            effect="blur"
            placeholderSrc={imgSrc}
            alt="Loading..."
            className={className}
        />
    );
}

export default LazyImage;
